"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.basicInfo': '基本信息',
    'tutorial.form.name': '教程名称',
    'tutorial.form.description': '描述',
    'tutorial.form.introText': '介绍文字',
    'tutorial.form.active': '活跃',
    'tutorial.form.steps': '学习步骤',
    'tutorial.form.stepsDescription': '选择要包含在此教程中的学习步骤。',
    'tutorial.form.noStepsAvailable': '无可用学习步骤。请先创建一些步骤。',
    'tutorial.form.sections': '教程部分',
    'tutorial.form.addSection': '添加部分',
    'tutorial.form.sectionsDescription': '创建具有特定知识和提示的部分，用于引导学习。',
    'tutorial.form.section': '部分',
    'tutorial.form.sectionTitle': '部分标题',
    'tutorial.form.sectionDescription': '部分描述',
    'tutorial.form.sectionPrompt': '部分提示',
    'tutorial.form.sectionKnowledge': '知识库',
    'tutorial.form.namePlaceholder': '请输入培训名称...',
    'tutorial.form.avatar': '主导头像',
    'tutorial.form.avatarPlaceholder': '为此教程选择一个头像',
    'tutorial.form.selectAvatar': '选择头像...',
    'tutorial.form.company': '公司/任务',
    'tutorial.form.selectCompany': '选择公司...',
    'tutorial.form.descriptionPlaceholder': '简要描述此培训涵盖的内容...',
    'tutorial.form.introTextPlaceholder': '编写欢迎参与者的介绍文本...',
    'tutorial.form.step': '步骤',
    'tutorial.form.addStep': '添加步骤',
    'tutorial.form.stepName': '步骤名称',
    'tutorial.form.stepNamePlaceholder': '输入步骤名称',
    'tutorial.form.stepDescription': '步骤描述',
    'tutorial.form.stepDescriptionPlaceholder': '输入步骤描述（可选）',
    'tutorial.form.selectStep': '选择步骤...',
    'tutorial.form.sectionName': '节名称',
    'tutorial.form.sectionNamePlaceholder': '输入节名称...',
    'tutorial.form.sectionIntro': '节介绍',
    'tutorial.form.sectionIntroPlaceholder': '描述参与者将在本节中学到什么...',
    'tutorial.form.sectionPromptPlaceholder': '为此节提供知识或指导...',
    'tutorial.form.addKnowledge': '添加知识',
    'tutorial.form.selectedKnowledge': '选定的知识',
    'tutorial.form.files': '屏幕截图/屏幕',
    'tutorial.form.screenshot': '屏幕截图/屏幕',
    'tutorial.form.screenshotPlaceholder': '选择屏幕截图文件...',
    'tutorial.form.video': '视频（MP4）',
    'tutorial.form.videoPlaceholder': '选择视频文件...',
    'tutorial.form.screenshotMini': '屏幕截图缩略图',
    'tutorial.form.screenshotMiniPlaceholder': '选择屏幕截图缩略图...',
    'tutorial.form.videoMini': '视频缩略图',
    'tutorial.form.videoMiniPlaceholder': '选择视频缩略图...',
    'tutorial.form.attachments': '附件',
    'tutorial.form.addFile': '添加文件',
    'tutorial.form.sectionFileMiniature': '缩略图',
    'tutorial.form.sectionFileRequired': '请先选择文件再添加。',
    'tutorial.form.source.label': '来源',
    'tutorial.form.source.ai': 'AI生成',
    'tutorial.form.source.file': '扫描源文件并生成教程',
    'tutorial.form.sourceFile.label': '源文件',
    'tutorial.form.sourceFile.placeholder': '选择源文件...',
    'tutorial.form.scanPages.label': '索引/目录页码范围',
    'tutorial.form.scanSourceFile': '扫描源文件并填写教程表单',
    'tutorial.form.regenerateFromPdf': '从源文件重新生成',
    'tutorial.form.regenerateFromPdf.title': '从源文件重新生成教程？',
    'tutorial.form.regenerateFromPdf.confirm': '将根据源文件重新生成教程内容，并可能替换现有内容。是否继续？',
    'tutorial.form.tutorialGoal': '教程目标',
    'tutorial.form.tutorialGoalPlaceholder': '描述参与者完成本教程后应能做到什么...',
    'tutorial.form.examplePrompts_1': '创建一个滑雪基础入门教程，包含步骤、章节和待办事项',
    'tutorial.form.examplePrompts_2': '重写描述和介绍文本，使其与教程目标相符',
    'tutorial.form.examplePrompts_3': '为本教程的每个章节添加一个简短的待办清单',
    'tutorial.form.scanNeedsData': '请至少填写名称、目标或描述（或添加步骤），以便 AI 有内容可扩展',
    'tutorial.form.start.title': '你想如何开始？',
    'tutorial.form.start.onboarding.title': 'AI 课程创建器',
    'tutorial.form.start.onboarding.description': '回答一份关于课程的简短引导问卷，AI 将根据你的回答来塑造教程。',
    'tutorial.form.start.onboarding.action': '开始引导问卷',
    'tutorial.form.start.form.title': '空白教程',
    'tutorial.form.start.form.description': '自己填写表单、扫描源文件，或向 AI 助手寻求帮助。之后你仍可以在表单顶部添加引导流程。',
    'tutorial.form.start.form.action': '打开教程表单',
    'tutorial.form.start.form.how.title': '使用方式',
    'tutorial.form.start.form.how.step1': '为教程命名、选择分类，并添加描述和徽标。',
    'tutorial.form.start.form.how.step1.title': '填写教程基本信息',
    'tutorial.form.start.form.how.step2': '创建步骤和章节，并按参与者实际学习的顺序排列。',
    'tutorial.form.start.form.how.step2.title': '规划教程结构',
    'tutorial.form.start.form.how.step3': '为章节添加内容和附件，例如文件、图片和视频。',
    'tutorial.form.start.form.how.step3.title': '添加学习资料',
    'tutorial.form.start.form.how.step4': '添加学习任务，供参与者在完成后勾选。',
    'tutorial.form.start.form.how.step4.title': '添加学习任务',
    'tutorial.form.start.how.title': '使用方式',
    'tutorial.form.start.how.step1': '你将逐步完成一份简短的问卷：课程基础信息、受众、结构与时长、教学风格、材料、学习模式和认证。',
    'tutorial.form.start.how.step1.title': '回答几个问题',
    'tutorial.form.start.how.step2': '你的回答会附加到教程并与教程一起保存。',
    'tutorial.form.start.how.step2.title': '将回答与教程一同保存',
    'tutorial.form.start.how.step3': 'AI 在生成内容时会将其作为指令使用——无论是在 AI 助手中还是扫描源文件时——使结构、深度、语气和练习符合你的选择。',
    'tutorial.form.start.how.step3.title': '根据你的选择生成内容',
    'tutorial.form.assistant': '助手',
    'tutorial.scanned': '教程扫描完成，表单已填写',
    'tutorial.scanFailed': '扫描教程失败',
    'tutorial.category.loadFailed': '加载分类失败',
    'tutorial.form.expireAt': '到期日期',
    'tutorial.form.scanKnowledge.label': '或使用知识条目作为扫描来源',
    'tutorial.form.scanKnowledge.none': '未选择知识条目',
    'tutorial.form.source.ai.description': '教程内容将由 AI 实时生成。',
    'tutorial.form.source.file.description': '上传源文件（如 PDF）。将扫描其目录以构建教程。',
    'tutorial.form.scanSourceFile.description.ai': 'AI 将分析您已输入的数据，并补全缺失的教程结构（章节和步骤）。',
    'tutorial.form.scanSourceFile.description.file': '将扫描源文件以生成完整的教程结构及其内容（章节、步骤和文本）。',
    'tutorial.form.onboardingAttached': '已添加引导设置',
    'tutorial.form.scanProgress.step': '步骤',
    'tutorial.form.scanProgress.section': '部分',
    'tutorial.form.scanProgress.reading': '正在读取源文件...',
    'tutorial.form.scanProgress.index': '正在分析结构并规划章节...',
    'tutorial.form.scanProgress.content': '正在撰写章节内容',
    'tutorial.form.scanProgress.todos': '正在创建任务',
    'tutorial.form.source_pages': '章节来源页面',
    'tutorial.form.category': '类别',
    'tutorial.form.no_cat': '无类别',
    'tutorial.form.logo': '教程徽标',
    'tutorial.form.todoItems': '待办事项',
    'tutorial.form.todoItemPlaceholder': '输入待办事项...',
    'tutorial.form.todoDescription': '管理本教程的待办事项列表',
    'tutorial.form.addTodoItem': '添加待办',
    'tutorial.form.removeTodoItem': '删除待办',
    'tutorial.form.noTodoItems': '本教程没有待办事项',
    'tutorial.form.updatedFromAI': '表单已由AI助手更新',
    // Onboarding wizard
    'tutorial.form.onboarding.button': '引导创建',
    'tutorial.form.onboarding.submit': '生成课程',
    'tutorial.form.onboarding.stepLabel': '步骤',
    'tutorial.form.onboarding.step1': '基本信息',
    'tutorial.form.onboarding.step2': '受众',
    'tutorial.form.onboarding.step3': '课程参数',
    'tutorial.form.onboarding.step4': '课程风格',
    'tutorial.form.onboarding.step5': '需要生成的材料',
    'tutorial.form.onboarding.step6': '多媒体',
    'tutorial.form.onboarding.step7': '学习模式',
    'tutorial.form.onboarding.step8': '认证',
    'tutorial.form.onboarding.name': '课程名称',
    'tutorial.form.onboarding.category': '分类',
    'tutorial.form.onboarding.goals': '课程目标',
    'tutorial.form.onboarding.description': '课程描述（最多2000字符）',
    'tutorial.form.onboarding.level': '知识水平',
    'tutorial.form.onboarding.participants': '参与人数',
    'tutorial.form.onboarding.industries': '行业',
    'tutorial.form.onboarding.targetGroups': '目标群体',
    'tutorial.form.onboarding.totalHours': '课程总时长',
    'tutorial.form.onboarding.modulesCount': '步骤数量',
    'tutorial.form.onboarding.lessonsPerModule': '每个步骤的章节数',
    'tutorial.form.onboarding.lessonMinutes': '平均章节时长',
    'tutorial.form.onboarding.intensity': '强度',
    'tutorial.form.onboarding.styles': '授课风格',
    'tutorial.form.onboarding.tone': '沟通语气',
    'tutorial.form.onboarding.materials': 'AI 需要创建',
    'tutorial.form.onboarding.aiAvatar': 'AI 头像',
    'tutorial.form.onboarding.slides': '生成幻灯片',
    'tutorial.form.onboarding.narration': '生成旁白',
    'tutorial.form.onboarding.quizVideo': '生成测验视频',
    'tutorial.form.onboarding.graphics': '生成图形',
    'tutorial.form.onboarding.graphicsStyle': '图形风格',
    'tutorial.form.onboarding.theoryPracticeRatio': '理论 ←→ 实践',
    'tutorial.form.onboarding.exercisesCount': '练习数量',
    'tutorial.form.onboarding.caseStudiesCount': '案例研究数量',
    'tutorial.form.onboarding.finalProject': '结业项目',
    'tutorial.form.onboarding.finalExam': '结业考试',
    'tutorial.form.onboarding.certificate': '结业证书',
    'tutorial.form.onboarding.passThreshold': '及格线',
    'tutorial.form.onboarding.numbered': '编号证书',
    'tutorial.form.onboarding.qrVerification': '二维码证书验证',
    'tutorial.form.onboarding.goals.knowledge': '获取知识',
    'tutorial.form.onboarding.goals.skills': '获取技能',
    'tutorial.form.onboarding.goals.certification': '认证',
    'tutorial.form.onboarding.goals.process_implementation': '流程落地',
    'tutorial.form.onboarding.goals.sales_increase': '提高销售额',
    'tutorial.form.onboarding.goals.company_automation': '企业自动化',
    'tutorial.form.onboarding.goals.career_growth': '职业发展',
    'tutorial.form.onboarding.goals.exam_preparation': '备考',
    'tutorial.form.onboarding.levels.beginner': '初级',
    'tutorial.form.onboarding.levels.intermediate': '中级',
    'tutorial.form.onboarding.levels.advanced': '高级',
    'tutorial.form.onboarding.levels.expert': '专家',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': '电子商务',
    'tutorial.form.onboarding.industries.services': '服务业',
    'tutorial.form.onboarding.industries.production': '制造业',
    'tutorial.form.onboarding.industries.accounting': '会计',
    'tutorial.form.onboarding.industries.it': 'IT',
    'tutorial.form.onboarding.industries.education': '教育',
    'tutorial.form.onboarding.industries.real_estate': '房地产',
    'tutorial.form.onboarding.industries.medicine': '医疗',
    'tutorial.form.onboarding.industries.other': '其他',
    'tutorial.form.onboarding.targetGroups.business_owners': '企业主',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEO',
    'tutorial.form.onboarding.targetGroups.managers': '经理',
    'tutorial.form.onboarding.targetGroups.sales': '销售人员',
    'tutorial.form.onboarding.targetGroups.hr': '人力资源',
    'tutorial.form.onboarding.targetGroups.marketing': '市场营销',
    'tutorial.form.onboarding.targetGroups.developers': '开发人员',
    'tutorial.form.onboarding.targetGroups.freelancers': '自由职业者',
    'tutorial.form.onboarding.targetGroups.employees': '员工',
    'tutorial.form.onboarding.intensities.micro_learning': '微学习',
    'tutorial.form.onboarding.intensities.standard': '标准',
    'tutorial.form.onboarding.intensities.academy': '学院',
    'tutorial.form.onboarding.intensities.masterclass': '大师课',
    'tutorial.form.onboarding.styles.expert': '专家式',
    'tutorial.form.onboarding.styles.business': '商务式',
    'tutorial.form.onboarding.styles.formal': '正式',
    'tutorial.form.onboarding.styles.practical': '实用式',
    'tutorial.form.onboarding.styles.coaching': '教练式',
    'tutorial.form.onboarding.styles.storytelling': '故事式',
    'tutorial.form.onboarding.styles.mentoring': '导师式',
    'tutorial.form.onboarding.styles.workshop': '工作坊式',
    'tutorial.form.onboarding.tones.professional': '专业',
    'tutorial.form.onboarding.tones.friendly': '友好',
    'tutorial.form.onboarding.tones.dynamic': '活力',
    'tutorial.form.onboarding.tones.premium': '高端',
    'tutorial.form.onboarding.tones.corporate': '企业风格',
    'tutorial.form.onboarding.materials.outline': '大纲',
    'tutorial.form.onboarding.materials.full_lessons': '完整课时内容',
    'tutorial.form.onboarding.materials.presentations': '演示文稿',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': '练习册',
    'tutorial.form.onboarding.materials.checklists': '检查清单',
    'tutorial.form.onboarding.materials.quizzes': '测验',
    'tutorial.form.onboarding.materials.exams': '考试',
    'tutorial.form.onboarding.materials.certificate': '证书',
    'tutorial.form.onboarding.materials.practical_tasks': '实践任务',
    'tutorial.form.onboarding.materials.worksheets': '工作表',
    'tutorial.form.onboarding.materials.prompt_pack': '提示词包',
    'tutorial.form.onboarding.materials.case_study': '案例研究',
    'tutorial.form.onboarding.materials.landing_page': '落地页',
    'tutorial.form.onboarding.materials.sales_webinar': '销售网络研讨会',
    'tutorial.form.onboarding.materials.email_campaign': '邮件营销活动',
    'tutorial.form.onboarding.materials.social_posts': '社交媒体帖子',
    'tutorial.form.onboarding.materials.meta_ads': 'Meta 广告',
    'tutorial.form.onboarding.materials.google_ads': 'Google 广告',
    'tutorial.form.onboarding.imageStyles.photorealistic': '照片写实',
    'tutorial.form.onboarding.imageStyles.corporate': '企业风格',
    'tutorial.form.onboarding.imageStyles.minimalist': '极简',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': '信息图',
    'tutorial.form.onboarding.imageStyles.comic': '漫画',
    'tutorial.form.onboarding.imageStyles.premium': '高端',
    'tutorial.form.sourcePreview': '来源预览',
    'tutorial.form.editor.addField': '添加字段',
    'tutorial.form.editor.addOption': '添加选项',
    'tutorial.form.editor.fieldType': '字段类型',
    'tutorial.form.editor.label': '标签',
    'tutorial.form.editor.max': '最大值',
    'tutorial.form.editor.min': '最小值',
    'tutorial.form.editor.moveDown': '下移',
    'tutorial.form.editor.moveUp': '上移',
    'tutorial.form.editor.multiple': '多选',
    'tutorial.form.editor.name': '名称',
    'tutorial.form.editor.optionLabel': '选项标签',
    'tutorial.form.editor.optionValue': '选项值',
    'tutorial.form.editor.options': '选项',
    'tutorial.form.editor.placeholder': '占位符',
    'tutorial.form.editor.remove': '移除',
    'tutorial.form.editor.required': '必填',
    'tutorial.form.editor.rows': '行数',
    'tutorial.form.editor.showValue': '显示数值',
    'tutorial.form.editor.step': '步长',
    'tutorial.form.editor.submitLabel': '提交按钮标签',
    'tutorial.form.editor.type': '类型',
    'tutorial.form.editor.unit': '单位',
    'tutorial.form.editor.fieldType.input': '文本输入框',
    'tutorial.form.editor.fieldType.textarea': '文本区域',
    'tutorial.form.editor.fieldType.select': '下拉列表',
    'tutorial.form.editor.fieldType.radio': '单选按钮',
    'tutorial.form.editor.fieldType.checkbox': '复选框',
    'tutorial.form.editor.fieldType.date': '日期',
    'tutorial.form.editor.fieldType.switch': '开关',
    'tutorial.form.editor.fieldType.slider': '滑块',
    'tutorial.form.editor.inputFieldType.text': '文本',
    'tutorial.form.editor.inputFieldType.number': '数字',
    'tutorial.form.editor.inputFieldType.email': '电子邮件',
    'tutorial.form.editor.inputFieldType.password': '密码',
    'tutorial.form.editor.inputFieldType.tel': '电话',
    'tutorial.form.editor.inputFieldType.url': '网址',
    'tutorial.form.editor.inputFieldType.search': '搜索',
    'tutorial.form.editor.inputFieldType.date': '日期',
    'tutorial.form.editor.inputFieldType.datetime-local': '日期和时间',
    'tutorial.form.editor.inputFieldType.time': '时间',
    'tutorial.form.editor.defaultSubmitLabel': '提交',
    'tutorial.form.editor.defaultFieldLabel': '新字段',
    'tutorial.form.editor.defaultOptionLabel': '选项 {index}',
    'tutorial.form.editor.formEditor': '表单编辑器',
    'tutorial.form.editor.formIncluded': '表单已添加',
    'tutorial.form.editor.saveForm': '保存表单',
};
